import Vue from 'vue';
import Element from 'edu-custom-ui';
import 'edu-custom-ui/lib/theme-chalk/index.css';
import '../styles/common.scss';

Vue.use(Element, { size: 'small', zIndex: 3000 });
